import { PageRequest } from '../../../api/api.types';
import { Dispatch } from 'react';
import { AdminApi } from '../../../api/api.apiclient';
import {
  DELETE_SUPPLIER_BROKER,
  GET_SUPPLIER_BROKER,
  GET_SUPPLIER_BROKER_LIST,
  POST_SUPPLIER_BROKER,
  PUT_SUPPLIER_BROKER
} from '../types/supplierbroker.types';
import { EditSupplierBrokerRequest } from '../../../api/admin/admin.types';

export const getSupplierBrokerList = (pageRequest?: PageRequest) => async (dispatch: Dispatch<any>) => {
  const response = await AdminApi.supplierBrokers.listAllSupplierBrokers(pageRequest);

  dispatch({
    type: GET_SUPPLIER_BROKER_LIST,
    payload: {
      page: response.data
    }
  });
};

export const getSupplierBroker = (id: number) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await AdminApi.supplierBrokers.getOneSupplierBroker(id);
    dispatch({
      type: GET_SUPPLIER_BROKER,
      payload: {
        selectedSupplierBroker: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_SUPPLIER_BROKER,
      payload: {
        selectedSupplierBroker: null
      }
    });
  }
};

export const addNewSupplierBroker = (id: number, request: EditSupplierBrokerRequest) => async (dispatch: Dispatch<any>) => {
  const response = await AdminApi.supplierBrokers.addSupplierBroker(id, request);

  dispatch({
    type: POST_SUPPLIER_BROKER,
    payload: {
      success: true,
      selectedSupplierBroker: response.data
    }
  });
};

export const deleteSupplierBroker = (id: number) => async (dispatch: Dispatch<any>) => {
  await AdminApi.supplierBrokers.deleteSupplierBroker(id);
  dispatch({
    type: DELETE_SUPPLIER_BROKER,
    payload: {
      success: true
    }
  });
};

export const editSupplierBroker = (id: number, request: EditSupplierBrokerRequest) => async (dispatch: Dispatch<any>) => {
  const response = await AdminApi.supplierBrokers.editSupplierBroker(id, request);

  dispatch({
    type: PUT_SUPPLIER_BROKER,
    payload: {
      selectedSupplierBroker: response.data
    }
  });
};